import React from "react";

import KpiCard from "../../../CommonComponents/Dashboard/KpiCard/KpiCard";
import { KPI_CARD_BACKGROUND } from "../../../../utils/Constants";

import "./stylesProviderStatistics.css";

function ProviderStatistics({ provider, isApiRunning }) {
  return (
    <div className="provider-statistics">
      {provider && <h2>{provider} Statistics</h2>}
      <div className="provider-statistics__content">
        <div className="left-content">
          <div className="top">
            <KpiCard
              isApiRunning={isApiRunning}
              title="TURNOVER"
              value={799000}
              hugeValue={true}
              backgroundColor={KPI_CARD_BACKGROUND.TRASNPARENT}
            />
            <KpiCard
              isApiRunning={isApiRunning}
              title="PAID FUNDS"
              value={77100}
              hugeValue={false}
              percentage={5}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
          </div>
          <div className="bottom">
            <KpiCard
              isApiRunning={isApiRunning}
              title="UNPAID FUNDS"
              value={0}
              hugeValue={false}
              percentage={-9}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
            <KpiCard
              isApiRunning={isApiRunning}
              title="RETURNED FUNDS"
              value={0}
              hugeValue={false}
              percentage={5}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
          </div>
        </div>
        <div className="right-content">
          <div className="top">
            <KpiCard
              isApiRunning={isApiRunning}
              title="GGR"
              value={28000}
              hugeValue={false}
              percentage={9}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
            <KpiCard
              isApiRunning={isApiRunning}
              title="NGR"
              value={27500}
              hugeValue={false}
              percentage={3}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
          </div>
          <div className="bottom">
            <KpiCard
              isApiRunning={isApiRunning}
              title="GGR MARGIN"
              value={3.43}
              hugeValue={false}
              percentage={-9}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
            <KpiCard
              isApiRunning={isApiRunning}
              title="NGR MARGIN"
              value={3.43}
              hugeValue={false}
              percentage={9}
              backgroundColor={KPI_CARD_BACKGROUND.LIGHT}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProviderStatistics;
